module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de_at":{"why not less?":"Warum nicht weniger?","why not more?":"Warum nicht mehr?"},"cs":{"why not less?":"Proč ne méně?","why not more?":"Proč ne?"},"hu":{"why not less?":"Miért ne kevesebbet?","why not more?":"Miért ne?"},"fr":{"why not less?":"Pourquoi pas moins?","why not more?":"Pourquoi pas?"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/ingredients/ServingSelector.vue
// module id = 1165
// module chunks = 0